var _g, _path, _path2, _path3, _path4, _path5, _path6, _g2, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgEmptyStateHubspot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 36,
    viewBox: "0 0 118 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#EmptyStateHubspot_svg__filter0_d_1354_24068)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    width: 32,
    height: 32,
    rx: 8,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 7.5,
    stroke: "#E1E9F0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.452 8.385H18v15.23h-3.548c-1.414 0-1.927-.147-2.444-.423a2.882 2.882 0 01-1.2-1.2c-.276-.517-.423-1.03-.423-2.444v-7.095c0-1.415.147-1.928.424-2.445a2.883 2.883 0 011.199-1.2c.517-.276 1.03-.423 2.444-.423z",
    fill: "#148CFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 8.385h3.548c1.414 0 1.927.147 2.444.424.517.276.923.682 1.2 1.199.276.517.423 1.03.423 2.445V16H18V8.385z",
    fill: "#4DB1FD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.615 16v3.548c0 1.414-.147 1.927-.423 2.444a2.884 2.884 0 01-1.2 1.2c-.517.276-1.03.423-2.444.423H18V16h7.615z",
    fill: "#F2FAFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36 16h12",
    stroke: "#E1E9F0",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeDasharray: "1 3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59 25a9 9 0 119-9 9 9 0 01-9 9zm4.5-10.5h-9a.75.75 0 010-1.5h9a.75.75 0 010 1.5zM56 16h6a.75.75 0 010 1.5h-6a.75.75 0 010-1.5zm1.5 3h3a.75.75 0 010 1.5h-3a.75.75 0 010-1.5z",
    fill: "url(#EmptyStateHubspot_svg__paint0_linear_1354_24068)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70 16h12",
    stroke: "#E1E9F0",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeDasharray: "1 3"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#EmptyStateHubspot_svg__filter1_d_1354_24068)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84,
    width: 32,
    height: 32,
    rx: 8,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 7.5,
    stroke: "#E1E9F0"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.201 10.783v2.144a4.695 4.695 0 011.788 8.623 4.695 4.695 0 01-5.357-.258l-1.742 1.742c.045.142.07.29.071.44a1.527 1.527 0 11-1.528-1.529c.15.002.298.026.44.072l1.76-1.76a4.689 4.689 0 01-.07-5.283l-5.79-4.503a1.84 1.84 0 01-.915.248 1.86 1.86 0 111.861-1.856 1.841 1.841 0 01-.066.463l5.879 4.579a4.669 4.669 0 012.222-.978v-2.144a1.651 1.651 0 01-.952-1.488v-.05c0-.91.739-1.65 1.651-1.65h.05c.911 0 1.65.74 1.65 1.65v.05a1.651 1.651 0 01-.952 1.488zm-3.129 6.782a2.41 2.41 0 002.407 2.41h.003a2.41 2.41 0 10-2.41-2.41z",
    fill: "#FF7A59"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "EmptyStateHubspot_svg__filter0_d_1354_24068",
    x: 0,
    y: 0,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.482886 0 0 0 0 0.544786 0 0 0 0 0.599808 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1354_24068"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1354_24068",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "EmptyStateHubspot_svg__filter1_d_1354_24068",
    x: 82,
    y: 0,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.482886 0 0 0 0 0.544786 0 0 0 0 0.599808 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1354_24068"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1354_24068",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "EmptyStateHubspot_svg__paint0_linear_1354_24068",
    x1: 50,
    y1: 7,
    x2: 50,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EDC9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1DC463"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateHubspot);
export default ForwardRef;